var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 102C8.21667 102 5.54767 100.889 3.32634 98.668C1.10501 96.4467 -0.00376816 93.7795 9.62083e-06 90.6667V11.3333C9.62083e-06 8.21667 1.11068 5.54767 3.33201 3.32634C5.55334 1.10501 8.22045 -0.00376816 11.3333 9.62083e-06H90.6667C93.7833 9.62083e-06 96.4523 1.11068 98.6737 3.33201C100.895 5.55334 102.004 8.22045 102 11.3333V90.6667C102 93.7833 100.889 96.4523 98.668 98.6737C96.4467 100.895 93.7795 102.004 90.6667 102H11.3333ZM22.6667 79.3333H62.3333V68H22.6667V79.3333ZM22.6667 56.6667H79.3333V45.3333H22.6667V56.6667ZM22.6667 34H79.3333V22.6667H22.6667V34Z",
    fill: "#f8f8f8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument2);
export default __webpack_public_path__ + "static/media/document2.fd1a40700f98f8cafee2f9703e4a93ac.svg";
export { ForwardRef as ReactComponent };